<template>
  <BbBtn class="button-container" :class="{ selected }" size="large" @click="$emit('click')">
    <BbIcon v-if="icon" :size="iconSize" :name="icon" />
    <TextBody :i18n-key="textKey" :text="text" tag="span" :body-type="1" weight="medium" />
  </BbBtn>
</template>
<script>
import TextBody from '~/components/common/TextBody.vue';

export default {
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    textKey: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: 'medium',
    },
  },
  components: {
    TextBody,
  },
  emits: ['click'],
};
</script>

<style scoped lang="scss">
.button-container {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  background-color: $bb-neutral-6 !important;
  border-radius: $bb-spacing-5;
  margin: $bb-spacing-3 0 $bb-spacing-3 0;

  &:hover {
    :deep(.v-btn__content) {
      span {
        color: $bb-neutral-0 !important;
      }

      i {
        color: $bb-neutral-0 !important;
      }
    }
  }

  :deep(.v-btn__content) {
    gap: $bb-spacing-2;

    i {
      color: $bb-neutral-1;
    }
  }
}

.selected {
  border: 1px solid $bb-primary-3 !important;

  :deep(.v-btn__content) {
    span {
      color: $bb-primary-3 !important;
    }

    i {
      color: $bb-primary-3;
    }
  }

  &:hover {
    :deep(.v-btn__content) {
      span {
        color: $bb-neutral-0 !important;
      }
    }
  }
}
</style>
